// extracted by mini-css-extract-plugin
export default {"container":"Products_container__F-9XW","menu":"Products_menu__gCXjX","list":"Products_list__DQ2k-","products":"Products_products__E1c+N","product":"Products_product__YPIQE"};